import EVENTS from '@shared/events';
import { BaseController } from '@shared/basecontroller.controller';
import numeral from 'numeral';
import { showModal } from '../../ui/modal.util';

export class CustomerProductsList {
    constructor(customerProducts) {
        this._customerProducts = customerProducts;
    }

    get customerProducts() {
        return this._customerProducts;
    }

    get balance() {
        let balance = numeral(0);

        for (const customerProduct of this.customerProducts) {
            balance = balance.add(customerProduct.balance);
        }

        return balance.format('0,0.00');
    }
}

export class CustomerProductWidgetController extends BaseController {
    constructor(CustomerApiService, AppService, $scope) {
        'ngInject';

        super(AppService);

        this.CustomerApiService = CustomerApiService;
        this.$scope = $scope;

        this.$scope.$on('reload.customer-products', () => {
            this.loadCustomerProducts();
        });
    }

    $onInit() {
        this.loadCustomerProducts();
        
        this.addListener(EVENTS.PRODUCT_REQUESTED, event => {
            this.refreshProducts();
        });

        this.addListener(EVENTS.TRANSACTION_PROCESSED, event => {
            this.refreshProducts();
        });
    }

    loadCustomerProducts() {
        this.CustomerApiService.getProducts().then(customerProducts => {
            this.customerProducts = customerProducts;
            this.onCustomerProductsLoaded({ customerProductsList: new CustomerProductsList(this.customerProducts) });
        });
    }

    refreshProducts() {
        this.loadCustomerProducts();
    }
}

export default CustomerProductWidgetController;


// WEBPACK FOOTER //
// ./client/app/shared/system-components/customer-product-widget/customer-product-widget.controller.js